import { render, staticRenderFns } from "./PB-Datepicker.vue?vue&type=template&id=40882296&scoped=true&"
import script from "./PB-Datepicker.vue?vue&type=script&lang=js&"
export * from "./PB-Datepicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40882296",
  null
  
)

export default component.exports